import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Store, CheckCircle2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function AttivaAccount() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null); // {valid, email, business_name, expired}
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setInfo({ valid: false }); return; }
    api.get(`/auth/activate/${token}`).then(({ data }) => setInfo(data)).catch(() => setInfo({ valid: false }));
  }, [token]);

  const activate = async () => {
    if (pw.length < 6) return toast.error("La password deve avere almeno 6 caratteri");
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/activate", { token, password: pw });
      localStorage.setItem("fuma_token", data.token);
      toast.success("Account attivato! Benvenuto su Fuma c'anduma");
      window.location.href = "/business";
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#131316] p-7" data-testid="activate-card">
        <div className="font-display font-black text-2xl text-[#00E676] mb-1">Fuma c'anduma</div>
        <h1 className="font-['Unbounded'] font-bold text-xl mb-4 flex items-center gap-2"><Store className="h-5 w-5 text-[#00E676]" /> Attiva la tua attività</h1>

        {info === null && <p className="text-white/50 text-sm">Verifica invito in corso…</p>}

        {info && info.valid === false && (
          <div className="text-center py-6" data-testid="activate-invalid">
            <AlertTriangle className="h-10 w-10 mx-auto text-amber-400 mb-3" />
            <p className="text-white/70 text-sm">Questo link di attivazione non è valido o è scaduto. Contatta la Centrale operativa per ricevere un nuovo invito.</p>
          </div>
        )}

        {info && info.valid && (
          <div className="space-y-4" data-testid="activate-form">
            <div className="rounded-xl bg-[#0A0A0C] border border-white/10 p-3 text-sm">
              <div className="text-white/50 text-xs uppercase tracking-widest mb-1">Attività</div>
              <div className="font-semibold">{info.business_name}</div>
              <div className="text-white/50 text-xs mt-1">{info.email}</div>
            </div>
            <div><Label>Scegli una password</Label><Input data-testid="activate-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
            <div><Label>Conferma password</Label><Input data-testid="activate-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
            <Button data-testid="activate-submit" onClick={activate} disabled={busy} className="w-full bg-[#00E676] text-black rounded-full font-semibold">
              <CheckCircle2 className="h-4 w-4 mr-1.5" /> {busy ? "Attivazione…" : "Attiva e accedi"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
